export const sizingTemplateSchema = {
  type: 'array',
  items: {
    $ref: '#/definitions/response',
  },
  definitions: {
    response: {
      type: 'object',
      additionalProperties: true,
      properties: {
        allowUserOverride: {
          "anyOf": [
            { "type": "boolean" },
            { "type": "string", "enum": ["true", "false"] }
          ]
        },
        component: {
          type: 'string',
        },
        template: {
          $ref: '#/definitions/Template',
        },
      },
      required: [
        'component',
        'allowUserOverride',
        'template',
      ],
      title: 'response',
    },
    Template: {
      type: 'object',
      additionalProperties: false,
      properties: {
        $schema: {
          type: 'string',
          format: 'uri',
          'qt-uri-protocols': ['https'],
        },
        $id: {
          type: 'string',
          format: 'uri',
          'qt-uri-protocols': ['https'],
        },
        title: {
          type: 'string',
        },
        type: {
          type: 'string',
        },
        properties: {
          $ref: '#/definitions/TemplateProperties',
        },
        required: {
          type: 'array',
          items: {
            type: 'string',
          },
        },
      },
      required: ['properties', 'title', 'type'],
      title: 'Template',
    },
    TemplateProperties: {
      type: 'object',
      additionalProperties: {
        $ref: '#/definitions/component',
      },
      minProperties: 1,
      title: 'TemplateProperties',
    },
    component: {
      type: 'object',
      additionalProperties: false,
      properties: {
        type: {
          type: 'string',
        },
        title: {
          type: 'string',
        },
        properties: {
          $ref: '#/definitions/componentProperties',
        },
        required: {
          type: 'array',
          items: {
            type: 'string',
          },
        },
      },
      required: ['properties', 'title', 'type'],
      title: 'component',
    },
    componentProperties: {
      type: 'object',
      additionalProperties: {
        $ref: '#/definitions/additionalProperties',
      },
      minProperties: 1,
      title: 'componentProperties',
    },
    additionalProperties: {
      type: 'object',
      validateDefaultRange: true,
      properties: {
        type: {
          type: 'string',
          enum: ['integer', 'number', 'string'],
        },
        default: {
          type: ['integer', 'number', 'string'],
        },
        minimum: {
          type: ['number', 'string'],
        },
        maximum: {
          type: ['number', 'string'],
        },
        'x-unit': {
          type: 'string',
        },
        'x-override-allowed': {
          "anyOf": [
            { "type": "boolean" },
            { "type": "string", "enum": ["true", "false"] }
          ]
        },
      },
      required: ['default', 'type', 'x-override-allowed'],
      additionalProperties: false,
      title: 'additionalProperties',
    },
  },
};
